import { render, staticRenderFns } from "./EditFloorModal.vue?vue&type=template&id=633f7a88&"
import script from "./EditFloorModal.vue?vue&type=script&lang=js&"
export * from "./EditFloorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports